const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'relationship',
    ],

	config: {
		projectMeta: {}, // @see MARK: CUSTOMER_PROJECT_META_LOADER
		grantedMinorChangesForFieldCodes: {},
		subFormComponent: [
			'/',
			'templates',
			'customers',
			'projectTerms',
			'propertiesForm',
		],
	},

    methods: {
		showInsert(){
			const grantedChanges = ((this.model.projectMeta || {}).grantedChanges || {}).project || {}
			if(!grantedChanges.major && !this.config.creationMode){
				return this.performMessage({
					messageDisplay: {
						message: 'error:projects.projectTerms.notAbleToAddNewTermsAnyLonger'
					}
				})
			}

			return this.addRelationshipElement()
		},

        async delete(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
            buttonContext = buttonContext || 'projectTerms'

            const relationshipSourceComponent = (additionalData || {}).sourceComponent || {}
			const sourceComponentConfig = relationshipSourceComponent.config || {}
			const entityData = (relationshipSourceComponent.resourceData || {}).data || {}
			const entityAttributes = entityData.attributes || {}
			const entityID = entityAttributes[entityData.primaryKey || 'id']

			const messageBaseName = 'hint.delete.really'
			const context = await this.performDecision(
				'confirm',
				{
					component:  this,
					title:      storage.__(`${messageBaseName}.${buttonContext}.title`),
					message:    storage.__(`${messageBaseName}.${buttonContext}.message`)
				}
			)

			if (context.decision.type === 'yes') {
                if(entityID) {
                    await this.performAction(
                        this.prepareAction(`delete_${buttonContext}`, entityID)
                    )
                } else {
					this.subFieldsToModel(sourceComponentConfig.subFormAlias, {}, true, sourceComponentConfig.relationshipDataIndex, sourceComponentConfig.parentFormResourceKey)
					let firstOneFound = false
					// correct preventAllFieldLabels flag of first inline element if necessary
					this.find('base_form_form', undefined, function(form){
						if(form.componentIndex === relationshipSourceComponent.componentIndex){
							firstOneFound = true
						} else if(firstOneFound){
							form.config.preventAllFieldLabels = false
							form.refresh(false)
							return 'break'
						} else {
							return 'break'
						}
					})
                }

                this.model.nrOfRelationshipElements--
                relationshipSourceComponent.destroy()
			}
        },

		// which properties is a customer allowed to change?
		onBeforeRender(){
			if(!this.config.creationMode){
				if(utils.isEmpty(this.model.projectMeta)){
					this.locate('< templates_customers_projectTerms_controller', controller => {
						this.model.projectMeta = {
							...(controller.model.projectMeta || {})
						}
					})
				}
			}
		},


		// SPECIALS
		updateRelationshipElement(refElementHeadOptions, refResourceData, resourceKey, refActionExtension, refActionResourceRegister){
			const entityData = (refResourceData || {}).data || {}
			const entityAttributes = entityData.attributes || {}
			const entityID = entityAttributes[entityData.primaryKey || 'id']

			refActionResourceRegister.parentEntityForStatus = {
				baseFilters: {
					[entityData.primaryKey || 'id']: entityID,
					hindersCustomerOrder: this.scope === 'customers',
				}
			}
		},
    },

	hooks: {
		// which properties is a customer allowed to change?
		projectMetaChanged($element, options){
			this.model.projectMeta = (options || {}).projectMeta || {}
		},
	},
}